import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const updateProfileService = createApi({
  reducerPath: "update profile",
  baseQuery,
  endpoints: (builder) => ({
    updateProfile: builder.mutation({
      query: (formdata) => ({
        url: `/api/users/updateprofiles`,
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useUpdateProfileMutation } = updateProfileService;
